import React from 'react';
import BookingsList from '../components/bookings/BookingsList';

const VehicleBookings: React.FC = () => {
  return <BookingsList />;
};

export default VehicleBookings;
